import React from "react";
import { Box, Card, CardContent, Grid2, Typography } from "@mui/material";

interface InformationViewProps {
  title?: string;
  data: {
    label: string;
    value: string | number | React.ReactNode;
    columnSize?: number;
  }[];
  columns?: number;
}

const InformationView: React.FC<InformationViewProps> = ({
  title,
  data,
  columns = 10,
}) => {
  return (
    <Box>
      {title && (
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", paddingBottom: 2, color: "primary.main" }}
        >
          {title}
        </Typography>
      )}
      <Grid2 container spacing={2} columns={{ xs: 1, md: columns }}>
        {data.map((item, index) => (
          <Grid2
            key={index}
            size={{ xs: 1, md: item.columnSize || 1 }}
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <Typography
              variant="body1"
              sx={{ fontWeight: "bolder", color: "primary.main" }}
            >
              {item.label}:
            </Typography>
            <Typography variant="body1">{item.value}</Typography>
          </Grid2>
        ))}
      </Grid2>
    </Box>
  );
};

export default InformationView;
